import React, { useState, useRef, useCallback, useEffect } from 'react';

function ServiceTimeline({ services, compact = false }) {
    const [tooltip, setTooltip] = useState(null);
    const containerRef = useRef(null);

    // Dismiss tooltip on outside tap
    const handleOutsideClick = useCallback((e) => {
        if (containerRef.current && !containerRef.current.contains(e.target)) {
            setTooltip(null);
        }
    }, []);

    useEffect(() => {
        if (tooltip) {
            document.addEventListener('touchstart', handleOutsideClick);
            return () => document.removeEventListener('touchstart', handleOutsideClick);
        }
    }, [tooltip, handleOutsideClick]);

    if (!services || services.length === 0) return null;

    // Larger boxes on mobile (compact is used in mobile cards)
    const boxSize = compact ? 22 : 10;
    const gap = compact ? 3 : 2;

    const showTooltip = (e, label) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const parentRect = containerRef.current.getBoundingClientRect();
        setTooltip({
            text: label,
            left: rect.left - parentRect.left + rect.width / 2,
            top: rect.top - parentRect.top - 4,
        });
    };

    return (
        <div
            ref={containerRef}
            className="relative flex flex-wrap items-center"
            style={{ gap: `${gap}px` }}
        >
            {services.map((svc, i) => {
                const color = svc.present ? '#059669' : '#dc2626';
                const opacity = svc.type === 'wednesday' ? 0.85 : 1;
                const status = svc.present ? 'Present' : 'Absent';
                const [y, m, d] = svc.date.split('-').map(Number);
                const dayAbbr = new Date(y, m - 1, d).toLocaleDateString('en-US', { weekday: 'short' });
                const dateStr = `${dayAbbr} ${m}/${d}`;
                const label = `${dateStr} - ${status}${!svc.present && svc.reason ? ': ' + svc.reason : ''}`;

                return (
                    <div
                        key={`${svc.date}-${svc.type}`}
                        style={{
                            width: boxSize,
                            height: boxSize,
                            borderRadius: compact ? 4 : 2,
                            backgroundColor: color,
                            opacity,
                            cursor: 'default',
                            transition: 'transform 0.1s',
                            flexShrink: 0,
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.25)';
                            showTooltip(e, label);
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            setTooltip(null);
                        }}
                        onTouchStart={(e) => {
                            e.preventDefault();
                            showTooltip(e, label);
                        }}
                    />
                );
            })}
            {tooltip && (
                <div
                    className="absolute z-10 px-2 py-1 text-[10px] bg-slate-800 dark:bg-slate-700 text-white rounded shadow-lg whitespace-nowrap pointer-events-none"
                    style={{
                        left: tooltip.left,
                        top: tooltip.top,
                        transform: 'translate(-50%, -100%)',
                    }}
                >
                    {tooltip.text}
                </div>
            )}
        </div>
    );
}

export default ServiceTimeline;
